export default __webpack_public_path__ + "static/media/05-Shafique-Ibrahim.f3e54957.png";